<template>
  <div
    class="anz-fs-lead anz-color-black-50 anz-px-l-sm anz-pb-l anz-bb anz-mt-m"
  >
    {{ $translate('profile.labels.superLikeDescription') }}
  </div>
  <div class="anz-posts">
    <template v-for="post in superLikedPostList" :key="post.id">
      <post-single
        v-if="post"
        :post-root="post"
        open-respond-page
        show-link-to-topic
        hide-user-blog
        hide-username
        box-post
        strip-long-text
        :strip-long-text-length="183"
        strip-long-text-suffix="..."
        :strip-long-text-button="false"
      >
      </post-single>
    </template>
  </div>
  <a-loader v-if="loading" class-name="my-l"></a-loader>
  <div class="anz-align-center">
    <a-button
      class-name="anz-btn anz-btn-primary anz-wf-mo anz-btn-l"
      @click="loadNext"
      v-if="hasNext"
    >
      <template #title>
        {{ $translate('profile.actions.loadNext') }}
        <template v-if="remaining > 0"> ({{ remaining }}) </template>
      </template>
    </a-button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import AButton from '@/components/Forms/AButton.vue'
import ALoader from '@/components/ALoader.vue'
import PostSingle from '@/components/Post/PostSingle.vue'
import useSuperLikeManager from '@/composables/post-super-like/superLikeManager'

export default defineComponent({
  name: 'SuperLikeList',
  components: { PostSingle, ALoader, AButton },
  async setup() {
    const {
      superLikedPostList,
      remaining,
      loading,
      loadNext,
      clear,
      hasNext,
    } = useSuperLikeManager()

    clear()
    await loadNext()

    return {
      superLikedPostList,
      remaining,
      loading,
      hasNext,
      loadNext,
    }
  },
})
</script>
